import Auth, { useUser } from "@dashboard/auth";
import LoginLoading from "@dashboard/auth/components/LoginLoading/LoginLoading";
import { useAuthRedirection } from "@dashboard/auth/hooks/useAuthRedirection";
import useAppChannel from "@dashboard/components/AppLayout/AppChannelContext";
import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import { Box, Button, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";
import { Redirect, Switch } from "react-router-dom";

import { operatorMessages } from "./messages";
import { operatorModulesFor } from "./modules";
import { OperatorLayout } from "./OperatorLayout";

const NoAccess = () => {
  const intl = useIntl();
  const { logout } = useUser();

  return (
    <Box display="grid" placeItems="center" __minHeight="100vh" padding={6}>
      <Box display="flex" flexDirection="column" gap={4} __maxWidth={420}>
        <Text size={8} fontWeight="bold">
          {intl.formatMessage(operatorMessages.noAccessTitle)}
        </Text>
        <Text color="default2">{intl.formatMessage(operatorMessages.noAccessBody)}</Text>
        <Box>
          <Button variant="primary" onClick={() => logout?.()}>
            {intl.formatMessage(operatorMessages.logout)}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

/**
 * Routes for the operator platform (see operatorHost.ts). The role comes from
 * the login: only the modules the user's permissions grant are routed at
 * all, and the first one is the landing page. Everything else in the
 * dashboard is simply unreachable from this host.
 */
export const OperatorRoutes = () => {
  const intl = useIntl();
  const { user } = useUser();
  const { authenticated, authenticating } = useAuthRedirection();
  const { channel } = useAppChannel(false);
  const channelLoaded = typeof channel !== "undefined";
  const modules = operatorModulesFor(user);

  return (
    <>
      <WindowTitle title={intl.formatMessage(operatorMessages.platformName)} />
      {authenticated && channelLoaded ? (
        modules.length === 0 ? (
          <NoAccess />
        ) : (
          <OperatorLayout modules={modules}>
            <Switch>
              {modules.map(module => (
                <Route key={module.id} path={module.path} component={module.component} />
              ))}
              <Redirect to={modules[0].path} />
            </Switch>
          </OperatorLayout>
        )
      ) : (authenticated && !channelLoaded) || authenticating ? (
        <LoginLoading />
      ) : (
        <Auth />
      )}
    </>
  );
};
